import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);
const LS_KEY = "ssr_wishlist_v1";

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    async function load() {
      if (user) {
        try {
          const { data } = await api.get("/wishlist");
          setIds(data.product_ids);
        } catch { setIds([]); }
      } else {
        setIds(JSON.parse(localStorage.getItem(LS_KEY) || "[]"));
      }
    }
    load();
  }, [user]);

  const persistGuest = (next) => localStorage.setItem(LS_KEY, JSON.stringify(next));

  const toggle = useCallback(async (product) => {
    const pid = product.id;
    if (user) {
      const { data } = await api.post("/wishlist/toggle", { product_id: pid });
      setIds(data.product_ids);
      toast(data.product_ids.includes(pid) ? "Added to wishlist" : "Removed from wishlist");
    } else {
      const has = ids.includes(pid);
      const next = has ? ids.filter((x) => x !== pid) : [...ids, pid];
      setIds(next); persistGuest(next);
      toast(has ? "Removed from wishlist" : "Added to wishlist");
    }
  }, [ids, user]);

  const has = (pid) => ids.includes(pid);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
